export default "__VITE_ASSET__CwsGsSqq__"